import React, { useState } from 'react';


const FileUpload = ({ field, form, label, ...props }) => {
    const [fileName, setFileName] = useState('');

    const handleChange = (event) => {
        const file = event.currentTarget.files[0];
        setFileName(file ? file.name : '');
        form.setFieldValue(field.name, file);
    };

    return (
        <div className="space-y-2">
            <label className="block text-sm font-medium text-gray-700">{label}</label>
            <div className="flex items-center space-x-2">
                <input
                    type="file"
                    onChange={handleChange}
                    style={{ display: 'none' }}  // Make sure no children are passed here
                    id={field.name}
                    accept=".pdf,.jpg,.jpeg,.png"
                    {...props}  // Spread props should not include children or dangerouslySetInnerHTML
                />
                <label
                    htmlFor={field.name}
                    className="px-4 py-2 border border-gray-300 rounded-md shadow-sm text-sm font-medium text-gray-700 bg-white hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-purple-500 cursor-pointer"
                >
                    Choose File
                </label>
                <span className="text-sm text-gray-500">{fileName || 'No file chosen'}</span>
            </div>
        </div>
    );
};

export default FileUpload;
